import { render, staticRenderFns } from "./Manufacturers.vue?vue&type=template&id=64c16646&scoped=true"
import script from "./Manufacturers.vue?vue&type=script&lang=js"
export * from "./Manufacturers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c16646",
  null
  
)

export default component.exports